import { Theme } from '@routific/hive';
import { DateTime } from 'luxon';
import { DatePickerType } from '.';
import { DatePickerSlotProps } from '@mui/x-date-pickers/DatePicker/DatePicker.types';

const popperSx = {
  '& .MuiPaper-root': {
    borderRadius: 2,
    boxShadow: 3,
  },
  '& .MuiDayCalendar-weekDayLabel': {
    fontSize: '16px',
    color: Theme.Colors.textPrimary,
    margin: Theme.Spacing.xsSpacing,
  },
  '& .MuiDayCalendar-weekContainer': {
    margin: 0,
  },
  '& .MuiPickersDay-dayOutsideMonth': {
    color: Theme.Colors.textInvalid,
  },
};

export interface SlotPropsParams {
  hoveredDay: DateTime<boolean> | null,
  setHoveredDay: (day: DateTime<boolean> | null) => void,
  onChange: (newValue?: DateTime | null) => void,
  isFocused: boolean,
  setIsFocused: (val: boolean) => void,
  rangeStart?: DateTime | null,
  rangeEnd?: DateTime | null,
  value?: DateTime<boolean> | null,
  type?: DatePickerType,
  hasError?: boolean,
  dayHasRoutes?: (dayToCheck: any) => boolean;
  placeholder?: string;
}

export const getSlotProps = ({
  hoveredDay,
  setHoveredDay,
  onChange,
  isFocused,
  setIsFocused,
  rangeStart,
  rangeEnd,
  value,
  type,
  hasError,
  dayHasRoutes,
  placeholder,
}: SlotPropsParams) => ({
  yearButton: {
    sx: {
      '&.MuiPickersYear-yearButton': {
        borderRadius: 2,
        '&.Mui-selected': {
          backgroundColor: Theme.Colors.primary5,
        },
      },
    },
  },
  calendarHeader: {
    format: 'MMM yyyy',
    sx: {
      '&.MuiPickersCalendarHeader-root': {
        paddingLeft: Theme.Spacing.mdSpacing,
        paddingRight: Theme.Spacing.smSpacing,
      },
      '.MuiPickersCalendarHeader-label': {
        fontSize: '20px',
      },
      '.MuiPickersArrowSwitcher-spacer': {
        width: Theme.Spacing.xlSpacing,
      },
    },
  },
  day: (ownerState: any) =>
    ({
      selectedDay: value,
      hoveredDay,
      rangeStart,
      rangeEnd,
      rangeType: type,
      onPointerEnter: () => setHoveredDay(ownerState.day),
      dayHasRoutes,
    }) as any,
  actionBar: {
    actions: ['clear', 'today'],
    onClear: () => onChange(null),
    onSetToday: () => onChange(DateTime.now()),
  },
  openPickerIcon: { focused: isFocused },
  textField: {
    onFocus: () => setIsFocused(true),
    onBlur: () => setIsFocused(false),
    hasError,
    placeholder,
  } as any,
  popper: {
    sx: popperSx,
    placement: 'bottom',
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: [0, 8],
        },
      },
    ],
  },
} as DatePickerSlotProps<any, false>);

